import { index } from "@/services/service_managers";

export default {
  namespaced: true,
  state: {
    service_managers: []
  },
  getters: {
    getServiceManagers(state) {
      return state.service_managers;
    }
  },
  mutations: {},
  actions: {
    async loadServiceManagers({ state }) {
      if (state.service_managers.length == 0) {
        try {
          const managers = await index({ list: true });
          state.service_managers = managers ? managers : [];
        } catch (error) {
          console.error("erro ao buscar service_managers", error);
        }
      } else {
        return false;
      }
    }
  }
};
